import { TCPOS } from "@constants";

import React from "react";

import useSalesModesChangeConfirmationDialog from "./SalesModesChangeConfirmationHook";
import { SalesModesChangeConfirmationModal } from "./SalesModesChangeConfirmationModal";
import SalesModesClearConfirmationDialog from "./SalesModesClearConfirmationDialog";

export function SalesModesChangeConfirmationDialog({
    open,
    onClose,
    salesMode,
    filledBasketIconContent,
}: SalesModesChangeConfirmationDialogType): JSX.Element {
    const { posEditor, orderItems } = useSalesModesChangeConfirmationDialog(
        salesMode,
        onClose
    );
    return orderItems.length === 0 || TCPOS === posEditor ? (
        <SalesModesClearConfirmationDialog onClose={onClose} open={open} />
    ) : (
        <SalesModesChangeConfirmationModal
            filledBasketIconContent={filledBasketIconContent}
            onClose={onClose}
            open={open}
        />
    );
}
